import { type UseQueryResult, useQuery } from 'react-query';

import { PagedResultDto_TrustedDeviceDto } from '@wealthlane/api-services/wealthlane-identity-service';
import { TrustedDeviceService } from '@wealthlane/api-services/wealthlane-identity-service';

const useGetTrustedDevices = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<PagedResultDto_TrustedDeviceDto | undefined, unknown> => {
  return useQuery(['getTrustedDevices'], async () => {
    return await handleRequest(
      TrustedDeviceService.getApiIdentityApiAppTrustedDevice(undefined, 0, 100)
    );
  });
};

export default useGetTrustedDevices;
